import AddTournamentModule from '@/modules/league-management/add-tour';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute(
  '/dashboard/fantasy/league-management/add-tour'
)({
  validateSearch: z.object({
    order: z.enum(['ASC', 'DESC']).default('DESC'),
  }),
  component: AddTournamentPage,
});

function AddTournamentPage() {
  return <AddTournamentModule />;
}
